

















































import Vue from 'vue'

import moment from 'moment'
import { Alarm } from '@/api/cems'

const momentDurationFormatSetup = require('moment-duration-format')
momentDurationFormatSetup(moment)

export default Vue.extend({
  name: 'ComponentName',
  props: {
    value: Array,
  },
  data() {
    return {
      fields: [
        { key: 'Status', thClass: 'column-status', tdClass: 'column-status' },
        { key: 'startDate', thClass: 'time-value' },
        { key: 'startTime', thClass: 'time-value' },
        { key: 'endDate', thClass: 'time-value' },
        { key: 'endTime', thClass: 'time-value' },

        { key: 'StartValue', thClass: 'time-value' },
        { key: 'EndValue', thClass: 'time-value' },

        { key: 'ackDate', thClass: 'time-value' },
        { key: 'ackTime', thClass: 'time-value' },
        // { key: 'AckValue', thClass: 'time-value' },

        // { key: 'class', thClass: 'column-class' },
        { key: 'duration', thClass: 'time-value' },
        { key: 'Message', label: 'Message' },
      ],
      model: {},
    }
  },
  methods: {
    getDate(v: Date): string {
      if (typeof v == 'undefined') {
        return ''
      }
      const m = moment(v)
      if (m.isValid()) {
        return m.format('DD-MM-YYYY')
      } else {
        return ''
      }
    },
    getTime(v: Date): string {
      if (typeof v == 'undefined') {
        return ''
      }
      const m = moment(v)
      if (m.isValid()) {
        return m.format('HH:mm:ss')
      } else {
        return ''
      }
    },

    getComingValue(item: Alarm): string {
      if (typeof item.StartValue != 'number') {
        return item.StartValue
      }
      return item.StartValue.toFixed(3)
    },

    getAckValue(item: Alarm): string {
      if (typeof item.AckValue != 'number') {
        return item.AckValue
      }
      return item.AckValue.toFixed(3)
    },

    getGoingValue(item: Alarm): string {
      if (typeof item.EndValue != 'number') {
        return item.EndValue
      }
      return item.EndValue.toFixed(3)
    },

    getDuration(v: Alarm): string {
      let ms = 0
      if (v.Status.toUpperCase().indexOf('G') == -1) {
        ms = moment().diff(moment(v.StartTime))
      } else {
        ms = moment(v.EndTime).diff(moment(v.StartTime))
      }

      // eslint-disable-next-line
      return (moment.duration(ms) as any).format()
    },

    // eslint-disable-next-line
    rowClass(item: Alarm, type: string): string[] {
      const cls: string[] = [`alarm-${item.UID}`]

      // if (!item || type !== 'row') return cls

      // if (item.status.indexOf('C') != -1) {
      //   cls.push('active')
      // }

      // if (item.status.indexOf('A') != -1) {
      //   cls.push('ack')
      // }

      // if (item.status.indexOf('G') != -1) {
      //   cls.push('going')
      // }

      return cls
    },
  },
  watch: {
    value: function(val) {
      this.model = val
    },
  },
  created() {
    this.model = this.value
  },
})
